import * as React from 'react';
import { getNativeElementProps, slot } from '@fluentui/react-utilities';
import { useTableContext } from '../../contexts/tableContext';
/**
 * Create the state required to render TableHeader.
 *
 * The returned state can be modified with hooks such as useTableHeaderStyles_unstable,
 * before being passed to renderTableHeader_unstable.
 *
 * @param props - props from this instance of TableHeader
 * @param ref - reference to root HTMLElement of TableHeader
 */ export const useTableHeader_unstable = (props, ref)=>{
    const { noNativeElements } = useTableContext();
    var _props_as;
    const rootComponent = ((_props_as = props.as) !== null && _props_as !== void 0 ? _props_as : noNativeElements) ? 'div' : 'thead';
    return {
        components: {
            root: rootComponent
        },
        root: slot.always(getNativeElementProps(rootComponent, {
            ref,
            role: rootComponent === 'div' ? 'rowgroup' : undefined,
            ...props
        }), {
            elementType: rootComponent
        }),
        noNativeElements
    };
};
